module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f433.1cb53613.svg";